import { DataGrid } from "@mui/x-data-grid";
import React, { useState } from "react";
import { MdCurrencyRupee } from "react-icons/md";
import { useNavigate } from "react-router";
import { all_routes } from "../../../router/all_routes";
import { Button } from "antd";
import { useSelector } from "react-redux";
import {
  ACCOUNTANT,
  CALLER,
  COMPANY_ADMIN,
  SUPER_ADMIN,
} from "../../../../core/data/constants/constant";
import PaymentApprovalModal from "./PaymentApprovalModal";
import { convertToUTCString } from "../../../../utils/helpers/helper";

const DealDetailsPayment = ({ deal }) => {
  const navigate = useNavigate();
  const route = all_routes;
  const { user } = useSelector((state) => state?.auth);
  const userRole = user?.role?.name;
  const isUserAccountant = userRole === ACCOUNTANT;
  const isUserCaller =
    userRole === CALLER ||
    userRole === SUPER_ADMIN ||
    userRole === COMPANY_ADMIN;

  const columns = [
    {
      field: "action",
      headerName: "Action",
      width: 60,
      renderCell: (params) => {
        const record = deal?.verificationRecord.find(
          (rec) => rec._id === params.row?._id
        );

        const isEditable =
          isUserAccountant ||
          (isUserCaller && record?.paymentStatus === "Pending");

        return (
          <button
            type="button"
            className="btn btn-sm btn-warning"
            onClick={() =>
              navigate(route.dealsDetails.replace(":id", `edit/${deal?._id}`), {
                state: {
                  verificationRecordId: params.row?._id,
                },
              })
            }
            disabled={!isEditable}
          >
            {isEditable ? (
              <i className="ti ti-pencil" />
            ) : (
              <i className="ti ti-lock" />
            )}
          </button>
        );
      },
    },
    { field: "index", headerName: "S.No", width: 50 },
    {
      field: "paymentDate",
      headerName: "Payment Date",
      width: 150,
      renderCell: (params) => (
        <div className="text-capitalize">{convertToUTCString(params.value,false)}</div>
      )
    },
    { field: "paymentId", headerName: "Payment ID", width: 150 },
    { field: "salesOrderNumber", headerName: "Sales Order Number", width: 150 },
    {
      field: "oldPaymentRemark",
      headerName: "Old Payment Remarks",
      width: 150,
      renderCell: (params) => (
        <div className="text-capitalize">{params.value}</div>
      ),
    },
    {
      field: "amountPaid",
      headerName: "Amount Paid",
      width: 150,
      renderHeader: () => (
        <span>
          Amount Paid (<MdCurrencyRupee />)
        </span>
      ),
    },
    { field: "paymentStatus", headerName: "Payment Status", width: 150 },
    { field: "remarkDate", headerName: "Remark Date", width: 150 },
    {
      field: "remark",
      headerName: "Remark",
      renderCell: (params) => (
        <div className="text-capitalize">{params.value}</div>
      ),
      width: 150,
    },
  ];

  return (
    <div>
      <>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h6 className="fw-semibold mb-3 fs-5 text-decoration-underline">
            Payment
          </h6>
          <div className="d-flex gap-2">
            {deal?.paymentDetails?.totalPaymentVerified && (
              <Button className="btn btn-success py-1" disabled>
                {deal?.paymentDetails?.totalPaymentVerified}
              </Button>
            )}
            {!deal?.dealVerifiedByAccountant &&
              !isUserAccountant &&
              deal?.editable && (
                <Button
                  type="primary"
                  data-bs-toggle="modal"
                  data-bs-target="#paymentApprovalModal"
                  className="fw-bold"
                >
                  Request Payment Approval
                </Button>
              )}
          </div>
        </div>
        {deal?.verificationRecord?.length > 0 && (
          <div className="row gx-5">
            <div style={{ width: "100%" }}>
              <DataGrid
                rows={deal?.verificationRecord.map((record, index) => ({
                  id: index,
                  index: index + 1,
                  ...record,
                }))}
                columns={columns}
                autoHeight
                hideFooter
                disableExtendRowFullWidth
              />
            </div>

            {deal?.paymentDetails?.amount > 0 && (
              <div className="row mt-1">
                <div
                  className="ms-auto d-flex justify-content-end border-bottom gap-5"
                  style={{
                    display: "inline-flex",
                    borderBottom: "2px solid black",
                    width: "fit-content",
                  }}
                >
                  <span className="fw-bold text-dark">Total Amount Paid:</span>
                  <span className="text-capitalize text-dark">
                    {deal?.paymentDetails?.amount ? (
                      <>
                        <MdCurrencyRupee size={15} />
                        {deal?.paymentDetails?.amount}
                      </>
                    ) : (
                      0
                    )}
                  </span>
                </div>
              </div>
            )}
          </div>
        )}
        <hr />
      </>

      <h6 className="mb-2 fw-semibold fs-5 text-decoration-underline">
        Amount / Payment Details
      </h6>
      <div className="row gx-5">
        <div className="d-flex justify-content-between col-md-6 mb-1">
          <span className="col-6 fw-bold">Amount:</span>
          <span className="col-6 text-capitalize">
            {deal?.paymentDetails?.amount ? (
              <>
                <MdCurrencyRupee size={15} />
                {deal?.paymentDetails?.amount}{" "}
              </>
            ) : (
              "N/A"
            )}
          </span>
        </div>

        <div className="d-flex justify-content-between col-md-6 mb-1">
          <span className="col-6 fw-bold">Total Payment Verified:</span>
          <span className="col-6 text-capitalize">
            {deal?.paymentDetails?.totalPaymentVerified ? (
              <>{deal?.paymentDetails?.totalPaymentVerified}</>
            ) : (
              "N/A"
            )}
          </span>
        </div>

        <div className="d-flex justify-content-between col-md-6 mb-1">
          <span className="col-6 fw-bold">Payment Received:</span>
          <span className="col-6 text-capitalize">
            {deal?.paymentDetails?.paymentReceived ? (
              <>{deal?.paymentDetails?.paymentReceived}</>
            ) : (
              "N/A"
            )}
          </span>
        </div>

        <div className="d-flex justify-content-between col-md-6 mb-1">
          <span className="col-6 fw-bold">Invoice Number:</span>
          <span className="col-6 text-capitalize">
            {deal?.paymentDetails?.invoiceNumber
              ? deal?.paymentDetails?.invoiceNumber
              : "N/A"}
          </span>
        </div>

        <div className="d-flex justify-content-between col-md-6 mb-1">
          <span className="col-6 fw-bold">Payment Status Remarks:</span>
          <span className="col-6 text-capitalize">
            {deal?.paymentDetails?.paymentStatusRemark ? (
              <>{deal?.paymentDetails?.paymentStatusRemark}</>
            ) : (
              "N/A"
            )}
          </span>
        </div>

        <div className="d-flex justify-content-between col-md-6 mb-1">
          <span className="col-6 fw-bold">Payment Description:</span>
          <span className="col-6 text-capitalize">
            {deal?.paymentDetails?.paymentDescription ? (
              <>{deal?.paymentDetails?.paymentDescription}</>
            ) : (
              "N/A"
            )}
          </span>
        </div>

        <div className="d-flex justify-content-between col-md-6 mb-1">
          <span className="col-6 fw-bold">Loan Amount:</span>
          <span className="col-6 text-capitalize">
            {deal?.paymentDetails?.loanAmount ? (
              <>{deal?.paymentDetails?.loanAmount}</>
            ) : (
              "N/A"
            )}
          </span>
        </div>

        <div className="d-flex justify-content-between col-md-6 mb-1">
          <span className="col-6 fw-bold">Loan Status:</span>
          <span className="col-6 text-capitalize">
            {deal?.paymentDetails?.loanStatus ? (
              <>{deal?.paymentDetails?.loanStatus}</>
            ) : (
              "N/A"
            )}
          </span>
        </div>
      </div>
      <hr />

      <PaymentApprovalModal
        dealData={deal}
        isUserAccountant={isUserAccountant}
      />
    </div>
  );
};

export default DealDetailsPayment;
